import React from "react";
import { useQuery } from "@tanstack/react-query";
import { getGameCategoryListAPI } from "../../api/user";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Loader from "../Loader/Loader";
import { Category1, Category2, Category3, Category4, Category5, Category6, Category7, Category8, Category9, Category10, Category11, Category12 } from "../../assets/images/home/categories/en";
import { Category1Ar, Category2Ar, Category3Ar, Category4Ar, Category5Ar, Category6Ar, Category7Ar, Category8Ar, Category9Ar, Category10Ar, Category11Ar, Category12Ar } from "../../assets/images/home/categories/ar";


const categories = {
  en: [Category1, Category2, Category3, Category4, Category5, Category6, Category7, Category8, Category9, Category10, Category11, Category12],
  ar: [Category1Ar, Category2Ar, Category3Ar, Category4Ar, Category5Ar, Category6Ar, Category7Ar, Category8Ar, Category9Ar, Category10Ar, Category11Ar, Category12Ar]
};

export default function Masonary() {
  const { i18n } = useTranslation();
  const language = i18n.language;
  const navigate = useNavigate();

  // const { data: categoryList, isLoading } = useQuery({
  //   queryKey: ["categoryList", language],
  //   queryFn: () => getGameCategoryListAPI({ page: 1 }),
  // });

  const categoryData =
    categories[language].map((item: any, index: number) => ({
      id: index + 1,
      img: item,
      categoryTitle: `Category ${index + 1}`,
    })) || [];


  if (categoryData.length === 0) {
    return null;
  }

  const handleCategoryClick = (path: string) => {
    navigate(path);
  };

  // Organize items into columns
  const getColumns = (columnCount: number) => {
    const columns: any[][] = Array.from({ length: columnCount }, () => []);
    categoryData.forEach((item, index) => {
      columns[index % columnCount].push(item);
    });
    return columns;
  };

  const renderColumns = (columnCount: number) => {
    const columns = getColumns(columnCount);
    return columns.map((columnItems, columnIndex) => (
      <div
        key={columnIndex}
        className={`flex flex-col ${columnIndex % 4 === 1 || columnIndex % 4 === 3 ? "-mt-5" : "mt-5"}`}
      >
        {columnItems.map((item) => (
          <div key={item.id} className="cursor-pointer group">
            <img src={item.img} alt={item.categoryTitle} className="w-full h-auto rounded-lg " />
          </div>
        ))}
      </div>
    ));
  };

  return (
    <div className="w-full mt-6">
      {/* Mobile: 4 columns, max 8 items (2 rows) */}
      <div className="flex md:hidden">
        {getColumns(4).map((columnItems, columnIndex) => (
          <div
            key={columnIndex}
            className={`flex flex-col flex-1 ${columnIndex % 4 === 1 || columnIndex % 4 === 3 ? "-mt-5" : "mt-5"}`}
          >
            {columnItems.slice(0, 3).map((item) => (
              <div key={item.id} className="cursor-pointer group" onClick={() => handleCategoryClick(item.path)}>
                <img
                  src={item.img}
                  alt={item.categoryTitle}
                  className="w-full h-auto rounded-lg transition-transform duration-300 hover:scale-105"
                />
              </div>
            ))}
          </div>
        ))}
      </div>
      {/* Tablet: 3 columns */}
      <div className="hidden md:flex lg:hidden">{renderColumns(5)}</div>
      {/* Desktop: 4 columns */}
      <div className="hidden lg:flex">{renderColumns(6)}</div>
    </div>
  );
}
